
(async () => {

  function convertToInternationalCurrencySystem (labelValue) {

    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e+9

    ? (Math.abs(Number(labelValue)) / 1.0e+9).toFixed(1) + "B"
    // Six Zeroes for Millions 
    : Math.abs(Number(labelValue)) >= 1.0e+6

    ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(1) + "M"
    // Three Zeroes for Thousands
    : Math.abs(Number(labelValue)) >= 1.0e+3

    ? (Math.abs(Number(labelValue)) / 1.0e+3).toFixed(1) + "K"

    : Math.abs(Number(labelValue));

  }
  
  const fetchPandaTypes = async () => {
    try { 

        const bt = JSON.parse("[{\"BodyTypeCount\":18,\"BodyType\":\"1 of 1\"},{\"BodyTypeCount\":98,\"BodyType\":\"Alien\"},{\"BodyTypeCount\":490,\"BodyType\":\"Golden\"},{\"BodyTypeCount\":250,\"BodyType\":\"Infinity\"},{\"BodyTypeCount\":6058,\"BodyType\":\"Normal\"},{\"BodyTypeCount\":3028,\"BodyType\":\"Red\"},{\"BodyTypeCount\":303,\"BodyType\":\"Zombie\"}]");  
    
        const tableRows = bt.map(({ BodyTypeCount, BodyType }) => ({
          bodyTypeCount: BodyTypeCount,
          bodyType: BodyType
        }));
        
          $('#panda-type-table').DataTable({
              order: [[0, 'desc']],
              data: tableRows,
              searching: false,
              "bPaginate": false,
              "ordering": false,
              info: false,
              columns: [
                  { title: 'Type',
                    data: 'bodyType',
                    className: 'dt-body-left',
                    render: function(data, type, row) {
                        var imgSrc = '';
                        if (data == 'Alien') {
                            imgSrc = 'https://sftpstgdrlpgcm7w5lya.blob.core.windows.net/assets/Body/Alien-100x100.png';
                        } else if (data == 'Golden') {
                            imgSrc = 'https://sftpstgdrlpgcm7w5lya.blob.core.windows.net/assets/Body/Golden-100x100.png';
                        } else if (data == 'Normal') {
                            imgSrc = 'https://sftpstgdrlpgcm7w5lya.blob.core.windows.net/assets/Body/Normal-100x100.png';
                        } else if (data == 'Red') {
                            imgSrc = 'https://sftpstgdrlpgcm7w5lya.blob.core.windows.net/assets/Body/Red-100x100.png';
                        } else if (data == 'Zombie') {
                            imgSrc = 'https://sftpstgdrlpgcm7w5lya.blob.core.windows.net/assets/Body/Zombie-100x100.png';
                        } else if (data == '1 of 1') {
                          imgSrc = 'https://sftpstgdrlpgcm7w5lya.blob.core.windows.net/assets/Body/Normal-100x100.png';
                      } else if (data == 'Infinity') {
                        imgSrc = 'https://sftpstgdrlpgcm7w5lya.blob.core.windows.net/assets/infinity/Body/Pink-100x100.png';
                    }
                        return '<img src="' + imgSrc + '" width="30px" />';
                    }
                  },
                  { title: 'Type',
                    data: 'bodyType',
                    className: 'dt-body-left',
                  },
                  { title: 'Supply',
                    data: 'bodyTypeCount',
                    className: 'dt-body-left',
                    render: $.fn.dataTable.render.number(',', '.', 0, '')
                  }
              ],
              
          });



    } catch (error) {
      console.error('Error fetching data:', error.message);
    }
  };

  const fetchPandas = async () => {
    try { 

          $('#pandas-table').DataTable({
              order: [[4, 'asc']],
              serverSide: true,
              processing: true,
              searching: false,
              "bLengthChange": false,
              "pageLength": 10,
              columns: [
                  { title: '', data: 'Id', orderable: false, className: 'dt-body-center p-1 pl-2',
                    render: function (data, type, row, meta) {
                      return type === 'display'
                      ? '<img src="https://prodftpserver.blob.core.windows.net/images/default/' + data + '-1000x1000?r=' + Math.floor(Math.random() * 100000) + '" width="50px" data-bs-toggle="tooltip" data-bs-placement="top" title="<div><img src=\'https://prodftpserver.blob.core.windows.net/images/default/' + data + '-1000x1000?r=' + Math.floor(Math.random() * 100000) + '\' width=\'150px\'/></div>" data-bs-html="true" />'
                      : data;
                    },
                  },
                  { title: 'Id', data: 'Id', className: 'dt-body-left',
                    render: function (data, type, row, meta) {
                      return type === 'display'
                          ? '<a href="panda.html?id=' + data + '">' + data + '</a>'
                          : data;
                    },
                  },
                  {
                    title: 'Price (Ξ)',
                    data: 'ListPrice',
                    className: 'dt-body-left',
                    render: function (data, type, row, meta) {
                        if (type === 'display') {
                            if (data === null) {
                                return '-';
                            } else {
                                return '<a href="' + row.Url + '" target="_blank" class="text-muted" title="Buy now"><button type="button" class="btn btn-white btn-xs" style="width:100px;"><img src="assets/images/marketplaces/' + row.Marketplace + '.svg" width="18px" style="padding-right:5px;margin-left:-5px;"/>' + row.ListPrice.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 4 }) + 'Ξ</button></a>';
                            }
                        }
                        return data;
                    },
                  },
                  { title: 'Collection', data: 'Collection', className: 'dt-body-left'},
                  { title: 'Rank', data: 'Rank', className: 'dt-body-left'},
                  { title: 'Default Rank', data: 'RankDefault', className: 'dt-body-left' },
                  {
                    title: 'Rank Change',
                    data: 'RankChange',
                    className: 'dt-body-left',
                    render: function (data, type, row, meta) {
                        const rankChange = row.RankChange;
                        let displayText = '-';
                        let textColorClass = '';
            
                        if (rankChange > 0) {
                            displayText = `+${rankChange}`;
                            textColorClass = 'text-success';
                        } else if (rankChange < 0) {
                            displayText = `${rankChange}`;
                            textColorClass = 'text-danger';
                        }
            
                        return type === 'display'
                            ? `<span class="${textColorClass}">${displayText}</span>`
                            : rankChange;
                    },
                  },
                  { title: 'Points Balance', data: 'PointsBalance', className: 'dt-body-left', render: $.fn.dataTable.render.number(',', '.', 0, '') },
                  { title: 'Points/day', data: 'PointsDaily', className: 'dt-body-left', render: $.fn.dataTable.render.number(',', '.', 0, '') },
                  { title: 'Owner', data: 'Owner', className: 'dt-body-left',
                    render: function (data, type, row, meta) {
                      if (!data) {
                        return '-';
                      }

                      const owner_displayname = row.OwnerEnsName ? row.OwnerEnsName : data.substring(0,5);
                      return type === 'display'
                          ? '<a href="profile.html?address=' + data + '">' + owner_displayname + '</a>'
                          : data;
                    },
                  }
              ],
              ajax: {
                url: 'https://api.pandastats.io/odata/pandastables?$count=true',
                dataSrc: function (data) {
                  data.recordsTotal = data["@odata.count"];
                  data.recordsDisplay = data["@odata.count"];
                  data.recordsFiltered = data["@odata.count"];
                  return data["value"]; 
                },
                data: function (params) {
                  return {
                    $top: params.length,
                    $skip: params.start,
                    $orderby: params.order[0].dir === 'asc' ? params.columns[params.order[0].column].data + ' asc' : params.columns[params.order[0].column].data + ' desc' || "rank asc",
                  };
                },
              },
              drawCallback: function() {

                const tooltips = $('#pandas-table').find('[data-bs-toggle="tooltip"]');
            
                // Destroy existing tooltips
                tooltips.each(function () {
                    var tooltipInstance = bootstrap.Tooltip.getInstance(this);
                    if (tooltipInstance) {
                        tooltipInstance.destroy();
                    }
                });
            
                // Create new tooltips
                tooltips.each(function () {
                    const content = $(this).attr('title');
                    $(this).attr('data-bs-html', 'true');
                    $(this).attr('title', '');
                    new bootstrap.Tooltip(this, {
                        placement: 'top',
                        html: true,
                        sanitize: false,
                        title: content
                    });
                });
              }
          });

    } catch (error) {
      console.error('Error fetching data:', error.message);
    }
  };
  
  function createSpotlightCard(id) {
    const card = document.createElement('div');
    card.classList.add('col-auto', 'mb-0', 'px-1');

    card.innerHTML = `
    <a href="panda.html?id=${id}">
      <div class="card p-0 mb-2" style="width: 100%;">
        <img src="https://prodftpserver.blob.core.windows.net/images/default/${id}-1000x1000?r=${Math.floor(Math.random() * 100000)}" class="img-fluid panda-image"/>
      </div>
      </a>
    `;

    return card;
  }

  const fetchAwards = async (address) => {
    try { 

      //rarest panda for sale
      const rarest_for_sale = await axios.get('https://api.pandastats.io/listings?$orderBy=rank&$top=1');
  
      if (rarest_for_sale.status === 200) {   
        const container = document.querySelector('#rarest-for-sale-container'); 
    
        let cards = [];
  
        for(let i = 0; i < rarest_for_sale.data.length; i++) {
          const card = createSpotlightCard(rarest_for_sale.data[i].TokenId);
          cards.push(card);
        }
  
        container.innerHTML = '';
        cards.forEach(card => container.appendChild(card));
        
      } else {
        console.error('Error fetching data:', response.statusText);
      }


      //most points held
      const most_points = await axios.get('https://api.pandastats.io/pandas?$orderBy=pointsbalance desc&$top=1');
  
      if (most_points.status === 200) {   
        const container = document.querySelector('#most-points-container'); 
    
        let cards = [];
  
        for(let i = 0; i < most_points.data.length; i++) {
          const card = createSpotlightCard(most_points.data[i].Id);
          cards.push(card);
        }
  
        container.innerHTML = '';
        cards.forEach(card => container.appendChild(card));
        
      } else {
        console.error('Error fetching data:', response.statusText);
      }


      //most improved rank
      const most_improved_rank = await axios.get('https://api.pandastats.io/odata/pandastables?$orderBy=rankchange desc&$top=1');
  
      if (most_improved_rank.status === 200) {   
        const container = document.querySelector('#most-improved-rank-container'); 
    
        let cards = [];
        
        for(let i = 0; i < most_improved_rank.data.value.length; i++) {
          const card = createSpotlightCard(most_improved_rank.data.value[i].Id);
          cards.push(card);
        }
  
        container.innerHTML = '';
        cards.forEach(card => container.appendChild(card));
        
      } else {
        console.error('Error fetching data:', response.statusText);
      }


      //most points for sale
      const most_points_for_sale = await axios.get('https://api.pandastats.io/listings?$orderBy=PointsBalance desc&$top=1');
  
      if (most_points_for_sale.status === 200) {   
        const container = document.querySelector('#most-points-for-sale-container'); 
    
        let cards = [];
        
        for(let i = 0; i < most_points_for_sale.data.length; i++) {
          const card = createSpotlightCard(most_points_for_sale.data[i].TokenId);
          cards.push(card);
        }
  
        container.innerHTML = '';
        cards.forEach(card => container.appendChild(card));
        
      } else {
        console.error('Error fetching data:', response.statusText);
      }

    } catch (error) {
      console.error('Error fetching data:', error.message);
    }
  };

  //fetchTopPanda(profileAddress);
  //fetchOwnerActivity(profileAddress);
  //fetchOwnerStats(profileAddress);
  fetchPandas();
  //fetchAwards();
  fetchPandaTypes();
  //fetchOwnerPandaBodyTypes(profileAddress);

})();